<div class="card-grid">
  <div *ngFor="let node of client?.projectStructure" class="card-item">
    <mat-card class="node-card">
      <img *ngIf="node.img" [src]="node.img" alt="{{ node.description }}" class="node-image" />

      <div class="card-content">
        <mat-checkbox
          [checked]="areAllModelsSelected(node)"
          (change)="toggleNodeSelection(node, $event)"
        >
          {{ node.description }}
        </mat-checkbox>
      </div>

      <div *ngIf="hasModels(0, node)" class="models">
        <div *ngFor="let model of node.models">
          <mat-checkbox
            [checked]="isModelSelected(model)"
            (change)="toggleModelSelection(model, $event)">
            {{ model.name }}
          </mat-checkbox>
        </div>
      </div>
    </mat-card>
  </div>
</div>
